import { ContentBlockType, SolverBlock } from '../../../model';

export const DEFAULT_SOLVER_PROPS = {
  type: ContentBlockType.Solver,
  slides: [],
} as const satisfies Partial<SolverBlock>;
